import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";
import { Img } from "@/assets";

export default function Divisions() {
  return (
    <>
      <Seo />
      <section className="gp-page-hero" data-testid="divisions-hero">
        <div className="gp-page-hero__img" aria-hidden="true">
          <Img id="port-aerial-dawn" alt="" />
        </div>
        <div className="gp-wrap gp-page-hero__inner">
          <div className="gp-eyebrow"><span className="gp-eyebrow-num">02</span><span className="gp-eyebrow-sep" /> Our Divisions</div>
          <h1 className="gp-h1 gp-page-hero__title">Two divisions. One standard of practice.</h1>
          <p className="gp-page-hero__lede">
            Gold Petroleum operates across petroleum and precious metals — two markets whose success
            depends on the same fundamentals: transparent counterparties, disciplined logistics and
            relationships that hold across cycles.
          </p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="divisions-tiles">
        <div className="gp-wrap">
          <div className="gp-panels">
            <Link to="/divisions/petroleum-energy" className="gp-panel" data-testid="tile-petroleum">
              <Img id="refinery-dusk-wide" />
              <span className="gp-panel__shade" aria-hidden="true" />
              <span className="gp-panel__body">
                <span className="gp-panel__eyebrow">01 · Division</span>
                <span className="gp-panel__title">Petroleum &amp; Energy</span>
                <span className="gp-panel__cta">See the division <span className="gp-arrow">→</span></span>
              </span>
            </Link>
            <Link to="/divisions/precious-metals" className="gp-panel" data-testid="tile-metals">
              <Img id="gold-dore-industrial" />
              <span className="gp-panel__shade" aria-hidden="true" />
              <span className="gp-panel__body">
                <span className="gp-panel__eyebrow">02 · Division</span>
                <span className="gp-panel__title">Precious Metals</span>
                <span className="gp-panel__cta">See the division <span className="gp-arrow">→</span></span>
              </span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
